(function ($) {

    $(".section-accordion-01 .panel-accordion").on("click", function (event) {
        // event.preventDefault();
        console.log(event.target);
        if ($(event.target).closest("a, button").length) {
            return;
        }

        let $collapse = $(this).find(".panel-collapse");

        if ($collapse.hasClass("show")) {
            $collapse.slideUp().removeClass("show");
            $(this).removeClass('opened');
        } else {
            $collapse.slideDown().addClass("show");
            $(this).addClass('opened');
        }
    });

})(jQuery);